import { gql } from '@apollo/client';

export const CORE_COLLECT_OVERVIEW_FIELDS = gql`
  fragment CoreCollectOverviewFields on CollectOverview {
    requestedProgress
    assignedById
    assignedToId
    category {
      id
      title
      level
    }
    dueDate
    facility {
      id
      name
    }
    id
    progress
    status
    year
  }
`;

export const CORE_USER_SETTINGS = gql`
  fragment CoreUserSettings on UserSettings {
    assignedTo
    categories
    facilities
    statuses
    rowsPerPageCount
    orderField
    orderDirection
    userId
    materialTopicsOrderDirection
    materialTopicsOrderField
    stakeholderSelectionOrderDirection
    stakeholderSelectionOrderField
    global_assignedTo
    global_categories
    global_orderDirection
    global_orderField
    global_rowsPerPageCount
    global_statuses
    esrsReportingChapter
    selectDataRowsPerPageCount
  }
`;
